module.exports = __webpack_public_path__ + "static/img/banner_2.87857a16.webp";